<section class="generate-with-ai-container">
  <div class="generate-with-ai-header">
    <div class="company-name">
      <img src="assets/images/icons/generate-ai-marble.svg">
    </div>
    <i class="db-icon db-icon-ds-close"
       id="close"
       (click)="close.emit()">
    </i>
  </div>
  <div class="generate-with-ai-title">
      {{ 'text_generateProductDescriptionWithAI' | dbText }}
  </div>
  <div>
    <div class="keywords-field-container">
      <div class="field-label">
          {{ 'text_enterFeaturesAndKeywords' | dbText }}
      </div>
      <input class="ds-input"
             [formControl]="keywordControl"
             type="text"
             placeholder="{{'text_featuresPlaceholder' | dbText}}">
    </div>
    <div class="voice-field-container">
      <div class="field-label">
          {{ 'text_toneOfVoice' | dbText }}
      </div>
      <ds-dropdown [dsDropdownOptions]="tonOfVoiceOptions"
                   [darkMode]="true"
                   [formControl]="voiceControl"
                   [dsDropdownFullyHover]="true"
                   [value]="'formal'">
      </ds-dropdown>
    </div>
    <div class="generate-with-ai-action">
      <a class="ds-btn transparent mr10"
         *ngIf="generated"
         (click)="onRegenerate()"
         [ngClass]="{'db-button_disabled': loading}">
        <span *ngIf="!loading">{{ 'text_regenerate' | dbText }}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
      <a class="ds-btn-blue"
         (click)="onGenerate()"
         [ngClass]="{'db-button_disabled': loading}">
        <span *ngIf="!loading || generated">{{(generated ? 'text_good':'text_generate') | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading && !generated"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</section>
